import request from '@/utils/request'
/**
 *
 * 员工管理
 *
 **/
// 登录
export const login = (data: any) =>
  request({
    url: '/employee/login',
    method: 'post',
    data: data
  })

// 退出
export const userLogout = (params: any) =>
  request({
    url: `/employee/logout`,
    method: 'post',
    params
  })

  export const getEmployeeList = (params: any) =>
  request({
    url: '/employee/page',
    method: 'get',
    params: params
  })

  // 启用/禁用员工
  export const startOrStopEmployee = (params: any) =>
  request({
    url: `/employee/status/${params.status}`,
    method: 'post',
    params: {
      id: params.id
    }
  })

  // 新增员工
  export const addEmployee = (data: any) =>
  request({
    url: '/employee',
    method: 'post',
    data: data
  })

  // 根据id查询员工
  export const getEmpById = (id: number) =>
  request({
    url: `/employee/${id}`,
    method: 'get'
  })

  // 编辑员工
  export const editEmployee = (data: any) =>
  request({
    url: '/employee',
    method: 'put',
    data: data
  })
